const page   = require('../../../../../components/page/page')
const customercreditDt = require('./customercredit-dt')

import customercreditPage       from "./customercredit-page.html";


/****************ELEMENTS*****************/
var HTMLwasSelected  = false

//insert the page  on the body
function HTMLselect(detail){ //console.log('customercredit init>')
	
	HTMLwasSelected = true

	//load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", customercreditPage)

   customercreditDt.start({"dest":"customercredit", "elem":"dt", "act":"select", "entity":"customercredit"})

}/*init*/

/****************ELEMENTS*****************/



export function start(detail){ 
   
  // console.log('customercredit page >', detail)
  
   if(!HTMLwasSelected) {HTMLselect(detail)}
	
	 obj[detail.act].start(detail)
}




const obj = {
   
      show:  { start: (detail)=>{  page.start(detail)     }},
}